<template>
  <div class="app-evn-settings-wrapper">
    <b-form>
      <b-row class="top-row">
        <div class="evn-header">
          <slot name="evnHeader"></slot>
        </div>
        <EvnSelect :evn-selected.sync="currentEvnConfiguration.evn" :plain-radio="true">
          <template v-for="slot in possibleChildSlotsFor('Select')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </EvnSelect>
      </b-row>
    </b-form>
    <Stepper
      @next="save()"
      :loading-next="loadingNext"
      :show-prev="false"
    >
      <template v-for="slot in possibleChildSlotsFor('Stepper')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Stepper>
  </div>
</template>

<script>
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import transaction from '@/mixins/transaction'
import { mapActions } from 'vuex'
import EvnSelect from '@/components/process/generic/ItemisedBills/Select.vue'
import Stepper from '../../../../generic/Stepper.vue'
import slotProxy from '@/mixins/slotProxy'
import { BRow } from 'bootstrap-vue'

export default {
  name: 'ChangeEvnWrapper',
  components: { EvnSelect, Stepper, BRow },
  data () {
    return {
      currentEvnConfiguration: {
        evn: ''
      },
      loadingNext: false
    }
  },
  methods: {
    ...mapActions('evn', [
      'saveEvnSettings'
    ]),
    save: async function () {
      this.loadingNext = true
      await this.saveEvnSettings({ selectedEvn: this.currentEvnConfiguration.evn })
      this.loadingNext = false
    }
  },
  mixins: [
    transaction('changeEvnSettings'),
    slotProxy()
  ],
  apollo: {
    currentEvnConfiguration: function () {
      return wrapQuery(
        gql`query changeEvnSettings {
          currentEvnConfiguration {
              evn
          }
        }`, this,
        'currentEvnConfiguration'
      )
    }
  }
}
</script>
